module.exports = __webpack_public_path__ + "images/screenshot-selectietool.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/img/support/screenshot-selectietool.jpg
// module id = 478
// module chunks = 0